// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__rPE+o","header":"Menu_header__gKedY","body":"Menu_body__-cZj3","footer":"Menu_footer__OmzKo"};